import { createFileRoute } from "@tanstack/react-router"
import { FeedPostCard } from "../-components/FeedPostCard"
import { ScrollContainer } from "../../../../../-components/scroll-container"
import { DefaultError } from "../../../../../-components/error-context"
import { Text } from "@mantine/core"
import { Page } from "../../../../../-components/Page"
import { useGetChatByIdSuspense, useGetFeedPostSuspense } from "@/orval/gen"

export const Route = createFileRoute("/app/com/feeds/$feedId/$postId")({
  component: RouteComponent,
  beforeLoad() {
    return {
      getTitle: undefined,
    }
  },
})

function RouteComponent() {
  const postId = Route.useParams().postId
  const feedId = Route.useParams().feedId
  const { data: chat } = useGetChatByIdSuspense({
    chatId: parseInt(feedId),
  })

  if (!chat) {
    throw new DefaultError({ title: "Chat not found." })
  }

  const { data: post } = useGetFeedPostSuspense({
    postId: parseInt(postId),
  })

  return (
    <Page crumbOverride={() => <Text size="xl">#{chat.name}</Text>}>
      <ScrollContainer align="center">
        <FeedPostCard feedPost={post} />
      </ScrollContainer>
    </Page>
  )
}
